import { DispatcherEvent } from '@carvana/merch-native';
import { useContext, useEffect } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import { NativeModalId } from '~/context/vdp/ModalContext/constants';
import sendMessageToNative from './sendMessageToNative';

// Tell the native app to open modals
function sendMessageToOpenNativeModal(
  modal: NativeModalId,
  onError: () => void,
  payload: Record<string, any> = {}
) {
  sendMessageToNative(
    DispatcherEvent.OpenModal,
    { modal, ...payload },
    { onError }
  );
}

export default function useModalMessageDispatcher() {
  const {
    isAddCoApplicantModalOpen,
    isEditCoApplicantModalOpen,
    isSoftPullModalOpen,
    setAddCoApplicantModalOpen,
    setEditCoApplicantModalOpen,
    setSoftPullModalOpen
  } = useContext(ModalContext);

  useEffect(() => {
    if (
      isAddCoApplicantModalOpen ||
      isEditCoApplicantModalOpen ||
      isSoftPullModalOpen
    ) {
      sendMessageToOpenNativeModal(NativeModalId.SoftPull, () => {
        setSoftPullModalOpen(false);
        setAddCoApplicantModalOpen(false);
        setEditCoApplicantModalOpen(false);
      });
    }
  }, [
    isAddCoApplicantModalOpen,
    isEditCoApplicantModalOpen,
    isSoftPullModalOpen,
    setAddCoApplicantModalOpen,
    setEditCoApplicantModalOpen,
    setSoftPullModalOpen
  ]);
}
